import React, { Fragment } from 'react';

import { withRouter } from 'react-router';
import { renderRoutes } from 'react-router-config';

import Footer from 'wanderu-component-footer';
import Helmet from 'wanderu-component-helmet';
import { Redirect } from 'wanderu-component-react-router-link';

import localesConfig from '../../config/baseApp.locales';

function UserAccounts(props) {
    const {
        match,
        route,
    } = props;

    if (match.isExact) {
        return (
            <Redirect href="/account/mytrips/upcoming/" />
        );
    }

    return (
        <Fragment>
            <Helmet
                supportedLocales={localesConfig.supportedLocales}
                noIndex
            />
            {renderRoutes(route.routes)}
            <Footer />
        </Fragment>
    );
}

export { UserAccounts };
export default withRouter(UserAccounts);
